import { useOnNewNotificationSubscription } from '@sit/client-shared';
import { useIsAuthenticated } from '@web/redux/hooks';

export function useLatestServerNotification() {
  const isAuthenticated = useIsAuthenticated();
  return useOnNewNotificationSubscription({ skip: !isAuthenticated });
}
